export enum DealStatus {
  FAILED = 'failed',
  AUTHORIZED = 'authorized',
  RESERVE_ONLINE_DETAILS_PROVIDED = '3200',
  CONTINUE_IN_DEALERSHIP_DETAILS_PROVIDED = '8200',
}
